const orgTypes = {
    MAS: 'mas',
    INSURANCE: 'Insurance',
    HOSPITAL: 'hospital',
    FACILITY: 'facility',
};
Object.freeze(orgTypes);
export default orgTypes;